import type { InjectionKey } from 'vue'

export type SetPageMeta = (meta: { title?: string; subtitle?: string }) => void
export type ClearPageMeta = () => void

export const setPageMetaKey: InjectionKey<SetPageMeta> = Symbol('setPageMeta')
export const clearPageMetaKey: InjectionKey<ClearPageMeta> = Symbol('clearPageMeta')
